import styled from "styled-components";

const InitBiometricSectionDefaultBox = styled.div`
  margin-bottom: 1rem;
  margin-top: 5rem;
  font-size: 1.6rem;
  color: ${({theme}) => theme.colors.textLight};
  
  > :nth-child(2n+1) {
    font-size: 1.4rem;
    color: ${({theme}) => theme.colors.textMiddleDark};
  }
`;

export const InitBiometricSectionBox = InitBiometricSectionDefaultBox;